import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

export const IconWaterfrontRoom: React.FC<IconProps> = ({
  size = 24,
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 52 52"
      fill={color}
      {...props}
    >
      {/* Outer square frame */}
      <rect x="5" y="5" width="42" height="42" rx="3" ry="3" fill="none" stroke={color} strokeWidth="2" />
      {/* Left curtain (solid) */}
      <path d="M7,8a1,1,0,0,1,1-1h10.04a69.1,69.1,0,0,1-2,10.68A88.5,88.5,0,0,1,12.37,27H7Zm0,21h5.05l.89,16H8a1,1,0,0,1-1-1Z" />
      {/* Right curtain (solid) */}
      <path d="M44,7a1,1,0,0,1,1,1V27H39.63a88.5,88.5,0,0,0-3.68-9.32A69.1,69.1,0,0,1,33.96,7ZM45,29H39.95l-.89,16H44a1,1,0,0,0,1-1Z" />
      {/* Center window area (outlined) */}
      <path d="M20.06,7h11.88a71.5,71.5,0,0,0,2.11,11.32,87.2,87.2,0,0,0,3.94,9.89l-.34,6.06L36,34.92l-4.63-1.85a1,1,0,0,0-.74,0L26,34.92l-4.63-1.85a1,1,0,0,0-.74,0L16,34.92l-1.65-.66-.34-6.06a87.2,87.2,0,0,0,3.94-9.89A71.5,71.5,0,0,0,20.06,7Z" fill="none" stroke={color} strokeWidth="1.5" />
      {/* Wave row 1 */}
      <path d="M37.31,40.4,36,40.92l-4.63-1.85a1,1,0,0,0-.74,0L26,40.92l-4.63-1.85a1,1,0,0,0-.74,0L16,40.92l-1.31-.52-.22-3.93,1.16.46a1,1,0,0,0,.74,0L21,35.08l4.63,1.85a1,1,0,0,0,.74,0L31,35.08l4.63,1.85a1,1,0,0,0,.74,0l1.16-.46Z" fill="none" stroke={color} strokeWidth="1.5" />
      {/* Wave row 2 */}
      <path d="M14.81,42.6l.82.33a1,1,0,0,0,.74,0L21,41.08l4.63,1.85a1,1,0,0,0,.74,0L31,41.08l4.63,1.85a1,1,0,0,0,.74,0l.82-.33L37.05,45H14.95Z" fill="none" stroke={color} strokeWidth="1.5" />
      {/* Water bird 1 */}
      <path d="M27,22a6.9,6.9,0,0,0-4,1.67A6.9,6.9,0,0,0,19,22a1,1,0,0,0,0,2,5.86,5.86,0,0,1,3.29,1.71,1,1,0,0,0,1.41,0A5.86,5.86,0,0,1,27,24a1,1,0,0,0,0-2Z" />
      {/* Water bird 2 */}
      <path d="M31,15a6.9,6.9,0,0,0-4,1.67A6.9,6.9,0,0,0,23,15a1,1,0,0,0,0,2,5.86,5.86,0,0,1,3.29,1.71,1,1,0,0,0,1.41,0A5.86,5.86,0,0,1,31,17a1,1,0,0,0,0-2Z" />
    </svg>
  );
};
